export const utf8ToBase64 = (str: string | number) => {
    const utf8Bytes = new TextEncoder().encode(String(str));  // Uint8Array
    const latin1 = Array.from(utf8Bytes, b => String.fromCharCode(b)).join('');
    return btoa(latin1);
}

export const base64ToUtf8 = (base64: string) => {
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}